var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUserGroupLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.625C16.136 8.625 14.625 10.136 14.625 12C14.625 13.864 16.136 15.375 18 15.375C19.864 15.375 21.375 13.864 21.375 12C21.375 10.136 19.864 8.625 18 8.625ZM12.375 12C12.375 8.89342 14.8933 6.375 18 6.375C21.1067 6.375 23.625 8.89342 23.625 12C23.625 15.1066 21.1067 17.625 18 17.625C14.8933 17.625 12.375 15.1066 12.375 12Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.875 6C22.875 5.37868 23.3787 4.875 24 4.875C27.1067 4.875 29.625 7.39342 29.625 10.5C29.625 12.795 28.2507 14.7666 26.2848 15.6413C25.7171 15.8939 25.0522 15.6384 24.7996 15.0708C24.547 14.5031 24.8025 13.8382 25.3701 13.5856C26.5536 13.0591 27.375 11.8743 27.375 10.5C27.375 8.63603 25.864 7.125 24 7.125C23.3787 7.125 22.875 6.62132 22.875 6Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 27C7.875 23.065 11.065 19.875 15 19.875H21C24.935 19.875 28.125 23.065 28.125 27V30C28.125 30.6213 27.6213 31.125 27 31.125H9C8.37868 31.125 7.875 30.6213 7.875 30V27ZM15 22.125C12.3076 22.125 10.125 24.3077 10.125 27V28.875H25.875V27C25.875 24.3077 23.6923 22.125 21 22.125H15Z",
    fill: "#76B72A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.875 19.5C25.875 18.8787 26.3787 18.375 27 18.375C30.935 18.375 34.125 21.565 34.125 25.5V28.5C34.125 29.1213 33.6213 29.625 33 29.625H30.75C30.1287 29.625 29.625 29.1213 29.625 28.5C29.625 27.8787 30.1287 27.375 30.75 27.375H31.875V25.5C31.875 22.8077 29.6923 20.625 27 20.625C26.3787 20.625 25.875 20.1213 25.875 19.5Z",
    fill: "#76B72A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 10.5C6.375 7.3934 8.8934 4.875 12 4.875C12.6213 4.875 13.125 5.37868 13.125 6C13.125 6.62132 12.6213 7.125 12 7.125C10.136 7.125 8.625 8.63605 8.625 10.5C8.625 11.8742 9.44647 13.0591 10.6298 13.5856C11.1975 13.8382 11.4529 14.5031 11.2004 15.0708C10.9478 15.6384 10.2829 15.8939 9.71519 15.6413C7.74932 14.7666 6.375 12.795 6.375 10.5Z",
    fill: "#76B72A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 25.5C1.875 21.565 5.06496 18.375 9 18.375C9.62132 18.375 10.125 18.8787 10.125 19.5C10.125 20.1213 9.62132 20.625 9 20.625C6.30762 20.625 4.125 22.8077 4.125 25.5V27.375H5.25C5.87132 27.375 6.375 27.8787 6.375 28.5C6.375 29.1213 5.87132 29.625 5.25 29.625H3C2.37868 29.625 1.875 29.1213 1.875 28.5V25.5Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserGroupLarge);
export default __webpack_public_path__ + "static/media/ic-user-group-large.86806a132fabd9fec18fb3b1c4304e95.svg";
export { ForwardRef as ReactComponent };